// ⚠️ MOCK — Onboarding Guide checklist steps (PRD §4.1).
// Step completion is persisted to localStorage (no backend yet). Each step
// deep-links to the relevant screen.

export interface GuideStep {
  /** i18n key suffix: guide.<key>.title / .desc */
  key: string;
  /** Deep-link route. */
  route: string;
  icon: string;
}

export const GUIDE_STEPS: GuideStep[] = [
  { key: 'connect', route: '/connect', icon: '🟢' },
  { key: 'verify', route: '/connect', icon: '📲' },
  { key: 'template', route: '/templates', icon: '🧩' },
  { key: 'import', route: '/subscribers', icon: '👥' },
  { key: 'broadcast', route: '/broadcasting', icon: '📣' },
];

/** Steps pre-completed on first visit (mock starting progress). */
export const GUIDE_SEED_DONE: string[] = ['connect'];

export const GUIDE_STORAGE_KEY = 'tagnologys.guide';
